// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {range} from '@benchling/js-utils';
import * as d3 from 'd3';
import {ScaleLinear} from 'd3';

import GapSequenceWrapper from 'analyses/alignment/GapSequenceWrapper';
import {assert} from 'Asserts';
import {GAP} from 'biojs/BioConstants';
import PolymerAxisView, {PolymerAxisViewOptions} from 'molbio/maps/linear/PolymerAxisView';
import Type from 'molbio/maps/Type';
import * as sequtil from 'molbio/SeqUtil';
import * as vo from 'settings/visibility-options/VisibilityOptions';

class GapToReal extends PolymerAxisView {
  static initClass(): void {
    this.prototype.className = 'gapToRealAxis';
    this.prototype.setting = vo.GAPTOREALAXIS.name;
  }

  initialize(options: PolymerAxisViewOptions): void {
    super.initialize(options);
    assert(this.model.get('sequence') instanceof GapSequenceWrapper, 'Expected a gap sequence wrapper!');
  }

  getBasesType(): Type {
    return this.model.get('layout').DNA.get('type');
  }

  /**
   * Create a piecewise D3 Linear Scale to map from display-formatted indices to a pixel offset,
   * accounting for any gaps. The scale's domain covers a contiguous interval of indices but the range
   * may repeat to account for gaps.
   *
   * For instance in the row alignment, given a start index of 1 and a max width of 100px:
   * G-T-
   *
   * The resulting piecewise scale for the gap sequence should map:
   * 1 => 0
   * 2 => 50
   * 4 => 100
   *
   * See D3 docs: https://observablehq.com/@d3/d3-scalelinear#piecewise
   */
  getScale(): ScaleLinear<number, number> {
    const _sequence = this.model.get('sequence').get('_sequence');
    const startIndex = this.getStartIndex();
    const xFn = this.slice.x();

    // Get max start and end for the original scale, but narrow to just the range if possible.
    let [gapStart, gapEnd] = xFn.domain();
    if (this.range != null) {
      // Need to clamp, because on short alignments, the `range` can extend beyond the bases.
      gapStart = Math.max(Math.floor(this.range.start()), 0);
      gapEnd = Math.min(Math.floor(this.range.end()), _sequence.length());
    }

    // Apply gapToReal because the indices are relative to the "absolute" scale, so need to be adjusted
    // to account for gaps in this particular gap sequence.
    const reals = range(_sequence.gapToReal(gapStart), _sequence.gapToReal(gapEnd) - 1);
    const ranges = reals.map((real) => xFn(_sequence.realToGap(real)));

    // Ensure that both extremes of the scale are covered.
    reals.unshift(0);
    ranges.unshift(0);
    reals.push(xFn.domain()[1]);
    ranges.push(xFn.range()[1]);

    return d3
      .scaleLinear()
      .domain(reals.map((real) => sequtil.modelToDisplay(real, startIndex)))
      .range(ranges);
  }

  setTicks(): void {
    let match;
    const _sequence = this.model.get('sequence').get('_sequence');
    const startIndex = this.getStartIndex();
    let sliceStart = this.slice.start();
    let sliceEnd = this.slice.end();

    if (this.range != null) {
      // Need to clamp, because on short alignments, the `range` can extend beyond the bases.
      sliceStart = Math.max(Math.floor(this.range.start()), 0);
      sliceEnd = Math.min(Math.floor(this.range.end()), _sequence.length());
    }

    const tickValues = [];

    let lastTickEndPxPos = -1000; // Any position before the first tick
    const xFn = this.slice.x();

    // For every stretch of contiguous bases (without a gap), include ticks from its start to end
    const bases = _sequence.bases().slice(sliceStart, sliceEnd);
    const pattern = new RegExp(`[^\\${GAP}]+`, 'g');
    // oxlint-disable-next-line no-cond-assign
    while ((match = pattern.exec(bases)) != null) {
      // Find the largest, friendly increment (1EX, 2EX, 5EX for some X) that spans a contiguous region,
      // that would include at least 8 visible ticks in the case the region is wider than the screen.
      const labelSpacing = this.getBasesType().numChars(this.slice.get('visibleWidth')! / 8);
      // oxlint-disable-next-line no-var, vars-on-top
      var minTarget = Math.min(labelSpacing, match[0].length);
      // oxlint-disable-next-line no-var, vars-on-top
      var diffs = [1, 2, 5];
      // oxlint-disable-next-line no-var, vars-on-top
      var prev = 1;
      const diff = (function () {
        let diff;
        prev = 1;
        diffs = [1, 2, 5];
        while (true) {
          for (diff of Array.from(diffs)) {
            if (diff > minTarget) {
              return prev;
            }
            prev = diff;
          }
          diffs = (() => {
            const result = [];
            for (diff of Array.from(diffs)) {
              result.push(10 * diff);
            }
            return result;
          })();
        }
      })();

      // Translate the indices to real axis values
      const start = sliceStart + match.index + 1;
      const end = start + match[0].length;
      let realStart = _sequence.gapToReal(start);
      let realEnd = _sequence.gapToReal(end - 1) + 1; // handle inclusive vs. exclusive basepair.
      realStart += startIndex - 1;
      realEnd += startIndex - 1;
      const oldRealStart = realStart;
      realStart = Math.ceil(realStart / diff) * diff;
      if (realEnd % diff !== 0) {
        realEnd = Math.floor(realEnd / diff) * diff + 1;
      }

      // Ensure at least the starting base gets labeled if there are too few bases.
      if (realStart === realEnd) {
        realStart = oldRealStart;
        realEnd = oldRealStart + 1;
      }

      // Include ticks from the start to end spaced out by diff.
      for (let index = realStart; index < realEnd; index += diff) {
        // For each tick we'd like to add, make sure it doesn't overlap with the last tick.
        const labelWidth = this.layout.get('type').width(String(index).length);
        const newTickStartPxPos = xFn(_sequence.realToGap(index)) - labelWidth / 2;
        if (newTickStartPxPos < lastTickEndPxPos) {
          continue;
        }
        lastTickEndPxPos = newTickStartPxPos + labelWidth;
        tickValues.push(index);
      }
    }
    this.axis.tickValues(tickValues);
  }
}
GapToReal.initClass();

export default GapToReal;
